import script from "./BrainSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./BrainSimple.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/objects/BrainSimple.css?vue&type=style&index=0&id=4ff4a704&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff4a704"]])

export default __exports__